import {getFilterSuggestions} from './getFilterSuggestions';
import {ISelectOption} from '@features/orders/interfaces';

export function getBrands(searchText: string = ''): Promise<ISelectOption[]> {
    return getFilterSuggestions('brand_name', searchText);
}

